import classNames from 'classnames';
import { IntlMessageFormat } from 'intl-messageformat';
import { useMemo } from 'react';

import styles from '../../../styles/blocks/stats-count.module.css';

interface StatsCountBlockProps extends StatsCountBlock {
    className?: string;
    isContainer?: boolean;
    containerClassName?: string;
}

function StatsCountBlock({
    body,
    count,
    className,
    isContainer,
    containerClassName,
}: StatsCountBlockProps) {
    const message = useMemo(() => new IntlMessageFormat(body).format({ count }), [body, count]);
    return (
        <div className={classNames([styles.container, className])}>
            <div
                className={classNames([
                    styles.inner,
                    {
                        [styles.isContainer]: isContainer,
                        [containerClassName]: isContainer && containerClassName !== null,
                    },
                ])}
            >
                <div className={styles.box}>{message}</div>
            </div>
        </div>
    );
}

export default StatsCountBlock;
